export default __webpack_public_path__ + "static/11-61785c44fd8a86da1fe184b85e2319d1.png";